import { useLocation, useNavigate } from "react-router-dom";
import { Home, Dumbbell, Users, CalendarDays, User, Apple, Heart, BookOpen } from "lucide-react";

const navItems = [
  { path: "/", label: "Ma", icon: Home },
  { path: "/workout", label: "Edzés", icon: Dumbbell },
  { path: "/community", label: "Közösség", icon: Users },
  { path: "/coach", label: "Coach", icon: CalendarDays },
  { path: "/profile", label: "Profil", icon: User },
];

const desktopExtra = [
  { path: "/nutrition", label: "Táplálkozás", icon: Apple },
  { path: "/recovery", label: "Regeneráció", icon: Heart },
  { path: "/academy", label: "Academy", icon: BookOpen },
];

export default function Layout({ children }) {
  const location = useLocation();
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#1a1a2e] pb-20 md:pb-0 md:pt-0">
      {/* Main content */}
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 page-active">
        {children}
      </main>

      {/* Bottom Navigation - Mobile */}
      <nav
        data-testid="bottom-navigation"
        className="fixed bottom-0 left-0 right-0 bg-[#1a1a2e]/95 backdrop-blur-xl border-t border-white/10 z-50 md:hidden"
      >
        <div className="flex items-center justify-around h-16 px-2">
          {navItems.map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                data-testid={`nav-${item.path.replace("/", "") || "home"}`}
                onClick={() => navigate(item.path)}
                className={`flex flex-col items-center gap-1 py-1 px-3 transition-all duration-200 ${
                  isActive ? "text-[#00f260]" : "text-gray-500 hover:text-gray-300"
                }`}
              >
                <Icon size={20} strokeWidth={isActive ? 2.5 : 1.5} />
                <span className="text-[10px] font-medium tracking-wide">{item.label}</span>
                {isActive && (
                  <div className="absolute bottom-1 w-1 h-1 rounded-full bg-[#00f260]" />
                )}
              </button>
            );
          })}
        </div>
      </nav>

      {/* Desktop Top Navigation */}
      <nav
        data-testid="top-navigation"
        className="hidden md:flex fixed top-0 left-0 right-0 bg-[#1a1a2e]/95 backdrop-blur-xl border-b border-white/10 z-50 h-16 items-center justify-between px-8"
      >
        <div className="flex items-center gap-2">
          <span className="font-heading text-xl font-bold tracking-wider text-[#00f260]">Athlevity</span>
        </div>
        <div className="flex items-center gap-1">
          {[...navItems.slice(0, 2), ...desktopExtra, ...navItems.slice(2)].map((item) => {
            const isActive = location.pathname === item.path;
            const Icon = item.icon;
            return (
              <button
                key={item.path}
                data-testid={`desktop-nav-${item.path.replace("/", "") || "home"}`}
                onClick={() => navigate(item.path)}
                className={`flex items-center gap-2 px-4 py-2 rounded-xl transition-all duration-200 ${
                  isActive
                    ? "bg-[#00f260]/10 text-[#00f260]"
                    : "text-gray-400 hover:text-white hover:bg-white/5"
                }`}
              >
                <Icon size={18} strokeWidth={1.5} />
                <span className="text-sm font-medium">{item.label}</span>
              </button>
            );
          })}
        </div>
      </nav>
    </div>
  );
}
